import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { BusRoute, BusStop } from '../../../apply/models/bus-pass-info';

@Component({
  selector: 'app-bus-route',
  templateUrl: './bus-route.component.html',
  styleUrls: ['./bus-route.component.css']
})
export class BusRouteComponent extends ComponentBase {

  @Input()
  public routes: BusRoute[];

  @Output()
  public stopSelected: EventEmitter<BusStop> = new EventEmitter<BusStop>();

  @Input()
  public selectedStop: BusStop;

  @Input()
  public buttonString: string;

  @Input()
  public countProperty: string;

  showRoutes: boolean = false;

  onSelectStop(stop: BusStop) {
    this.selectedStop = stop;
    this.stopSelected.emit(stop);
    this.showRoutes = false;
  }

}
